import { type PackagingInfoFormValues } from "../schemas/packaging"

import { type Product } from "@/graphql/codegen/graphql"

export enum PackagingInfoFormFieldIds {
  FreightClass = "freightClass",
  FreightItem = "freightItem",
  PackageDimensionsUom = "packageDimensionsUom",
  PackageHeight = "packageHeight",
  PackageLength = "packageLength",
  PackageMetricWeight = "packageMetricWeight",
  PackagesPerPallet = "packagesPerPallet",
  PackageUsWeight = "packageUsWeight",
  Uoms = "uoms",
  PackageWidth = "packageWidth",
  PackagingType = "packagingType",
  PalletMetricWeight = "palletMetricWeight",
  PalletSizeHeight = "palletSizeHeight",
  PalletSizeLength = "palletSizeLength",
  PalletSizeUom = "palletSizeUom",
  PalletSizeWidth = "palletSizeWidth",
  PalletUsWeight = "palletUsWeight",
}

export type PackagingInfo = Pick<
  Product,
  | "freightItem"
  | "freightClass"
  | "packagingType"
  | "packageUsWeight"
  | "packageMetricWeight"
  | "palletUsWeight"
  | "palletMetricWeight"
  | "palletSizeUom"
  | "packageLength"
  | "packageWidth"
  | "packageHeight"
  | "palletSizeLength"
  | "palletSizeWidth"
  | "palletSizeHeight"
  | "packagesPerPallet"
  | "packageUsWeightUomDetails"
  | "packageMetricWeightUomDetails"
  | "palletMetricWeightUomDetails"
  | "palletUsWeightUomDetails"
  | "packageUsWeightUom"
  | "packageMetricWeightUom"
  | "palletMetricWeightUom"
  | "palletUsWeightUom"
>

export interface PackagingInfoFormApi {
  submit: () => void
  isValid: boolean
}

export interface PackagingInfoFormProps {
  disabled?: boolean
  onSubmit: (data: Omit<PackagingInfoFormValues, "form">) => Promise<void>
  defaultValues?: Partial<Omit<PackagingInfoFormValues, "form">>
  onFormMount?: (api: PackagingInfoFormApi) => void
}

export interface PackagingUoms {
  us: string
  metric: string
}
